<template>
    <transition name="fade">
        <div v-if="this.$parent.currentSlide === slide" class="absolute inset-0 w-full h-full">
            <picture>
                <source media="(min-width: 1200px)" :srcset="imageLarge" />
                <source media="(min-width: 768px)" :srcset="imageMedium" />
                <img class="w-full h-full object-cover" :src="imageSmall" :alt="title" />
            </picture>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        slide: {
            required: true,
            type: Number
        },
        title: String,
        imageSmall: String,
        imageMedium: String,
        imageLarge: String
    }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s ease;
    overflow: hidden;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
